import "./relationshipView.scss";

import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";
import { findDOMNode } from "react-dom";
import ImmutablePropTypes from "react-immutable-proptypes";

import { colorMap } from "../../constants/colorOptions";
import { RELATIONSHIP_VIEW_COLUMN } from "../../constants/identifiers";
import { immutableRecords } from "../../types";
import { disableWhenIos } from "../../utils/codeSplit";
import hasAncestorOfClass from "../../utils/hasAncestorOfClass";
import { getLabelWithUntitled } from "../../utils/labelUtils";
import { asDragSource } from "../dragAndDrop/DraggableComponent";
import FormEditableLabel from "../form/FormEditableLabel";

const dragWasItemName = e => hasAncestorOfClass(e.target, "relationshipHeaderItemNameText");

const dragCallbacks = {
  beginDrag: _props => {
    // TODO: Do we want to set isDragging or similar...?
  },

  canDrag: (_props, dragSource, e) => {
    return dragSource.component.canDrag(e);
  },

  getDragSourceParams: props => {
    return {
      itemId: props.columnDisplayItem.id,
      itemType: props.columnDisplayItem.type,
      sourceView: props.viewId,
      sourceViewType: RELATIONSHIP_VIEW_COLUMN
    };
  },

  getPreviewElement: props => {
    return renderItem(props, null, null, true);
  }
};

const getInitialEditing = useProps => {
  let result = false;
  //#!if iOS !== true
  const { selectedItemIds, columnDisplayItem } = useProps;
  result = Boolean(useProps.isActiveView && selectedItemIds.contains(columnDisplayItem.id) && !columnDisplayItem.label);
  //#!endif
  return result;
};

const renderColumnColor = columnColor => {
  const color = colorMap[columnColor];
  const backgroundStyle = columnColor
    ? {
      backgroundColor: color,
      opacity: 0.15
    }
    : {};

  const borderStyle = columnColor
    ? {
      background: color,
      opacity: 0.4
    }
    : {};
  return (
    <Fragment>
      <div className="relationshipHeaderItemBackground" style={backgroundStyle} />
      <div className="relationshipHeaderItemColorBorder" style={borderStyle} />
    </Fragment>
  );
};

const renderItem = (itemProps, onLabelChange, onChangeEditing, isPreview = false) => {
  const col = itemProps.columnDisplayItem;

  const styles = {
    left: !isPreview ? `${col.left}px` : "0",
    opacity: !isPreview && itemProps.isDragging ? 0 : 1
  };
  const selected = itemProps.selectedItemIds.indexOf(col.id) >= 0;
  const entityColumnClasses =
    `rEntityCol` +
    (selected ? ` selected` : ``) +
    (itemProps.index % 2 === 0 ? " odd" : "") +
    (isPreview ? " preview" : "");
  const itemNameTextClasses = `relationshipHeaderItemNameText` + (isPreview ? " preview" : "");
  const placeholder = `${itemProps.label} ${itemProps.labelDisplay}`;

  return (
    <div key={col.id} style={styles} className={entityColumnClasses}>
      <div className="relationshipHeaderItemName">
        <div
          className={itemNameTextClasses}
          onClick={itemProps.onItemClick}
          onDoubleClick={disableWhenIos(itemProps.onItemDoubleClick)}
        >
          {renderColumnColor(itemProps.columnColor)}
          <div className="rtRotate">
            <span className={`colorDot  ${col.color}`} />
            <FormEditableLabel
              value={col.label}
              displayValue={getLabelWithUntitled(col.label)}
              isEditing={!isPreview && getInitialEditing(itemProps)}
              placeholder={placeholder}
              multiline={false}
              allowNewLine={false}
              onChange={onLabelChange}
              onChangeEditing={onChangeEditing}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

class RelationshipColumnHeaderColumnView extends PureComponent {
  constructor(props) {
    super(props);
    this._domNode = null;

    this.onChangeEditing = this.onChangeEditing.bind(this);
    this.onLabelChange = this.onLabelChange.bind(this);

    this._isEditing = false;
  }

  componentDidMount() {
    this._domNode = findDOMNode(this);
    this._isEditing = getInitialEditing(this.props);
  }

  canDrag(e) {
    return !this._isEditing && this.props.canDrag && dragWasItemName(e);
  }

  onChangeEditing(value) {
    this._isEditing = value;
  }

  onLabelChange(value) {
    this.props.onLabelChange([this.props.columnDisplayItem.id], value);
  }

  render() {
    return renderItem(this.props, this.onLabelChange, this.onChangeEditing);
  }
}

RelationshipColumnHeaderColumnView.propTypes = {
  index: PropTypes.number.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onItemDoubleClick: PropTypes.func.isRequired,
  columnDisplayItem: PropTypes.instanceOf(immutableRecords.RelationshipColumnDisplayRecord),
  isActiveView: PropTypes.bool.isRequired,
  selectedItemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  viewId: PropTypes.string.isRequired,
  onLabelChange: PropTypes.func,
  canDrag: PropTypes.bool,
  columnColor: PropTypes.string,
  label: PropTypes.string,
  labelDisplay: PropTypes.string,

  // From asDragSource
  isDragging: PropTypes.bool,
  dragIsFromSameSource: PropTypes.bool
};

export default asDragSource(RelationshipColumnHeaderColumnView, RELATIONSHIP_VIEW_COLUMN, dragCallbacks);
